import { render, staticRenderFns } from "./evaluations.vue?vue&type=template&id=f467c98e&"
import script from "./evaluations.vue?vue&type=script&lang=js&"
export * from "./evaluations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports